/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Sign_InInputs */

const en_auth_login_sign_in = /** @type {(inputs: Auth_Login_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const es_auth_login_sign_in = /** @type {(inputs: Auth_Login_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesion`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Auth_Login_Sign_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_login_sign_in = /** @type {((inputs?: Auth_Login_Sign_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Sign_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_login_sign_in(inputs)
	return es_auth_login_sign_in(inputs)
});